import { httpGetAndParse } from '../../utils/fetchService';

export const fetchFilingStates = ({ taxYear, period, entityId }) =>
  httpGetAndParse({
    route: `/api/entities/filing-states/${taxYear}/${period}/${entityId}`,
    errorMessage: 'Fetching filing states failed',
  });
